export class ProductionStaffModel {
  ProductionDashboardSummaryAPI: string = "";
  BenchMarkPages: string = "";
}
